module.exports = __webpack_public_path__ + "static/media/bridge_grey.cbb65de2.png";